import React, { useState, useEffect, useRef } from "react";
import { Building2, ChevronDown, Check } from "lucide-react";
import { useBranch } from "../../contexts/BranchContext";
import "../Branches/branches.scss";

const BranchSelector = () => {
  const { branches, selectedBranchId, selectBranch, isMultiBranch } = useBranch();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  // Don't render if multi-branch is not enabled or only 0-1 branches
  if (!isMultiBranch || branches.length <= 1) return null;

  const selectedBranch = branches.find(b => b._id === selectedBranchId);
  const displayLabel = selectedBranch ? selectedBranch.name : "All Branches";

  return (
    <div className="branch-selector" ref={ref}>
      <button
        type="button"
        className="branch-selector__trigger"
        onClick={() => setOpen(!open)}
      >
        <Building2 size={14} />
        <span className="branch-selector__label">{displayLabel}</span>
        <ChevronDown size={14} />
      </button>

      {open && (
        <div className="branch-selector__dropdown">
          <button
            type="button"
            className={`branch-selector__item ${selectedBranchId === 'all' ? 'branch-selector__item--active' : ''}`}
            onClick={() => { selectBranch('all'); setOpen(false); }}
          >
            All Branches
            {selectedBranchId === 'all' && <Check size={14} className="branch-selector__check" />}
          </button>
          {branches.filter(b => b.isActive).map((b) => (
            <button
              key={b._id}
              type="button"
              className={`branch-selector__item ${selectedBranchId === b._id ? 'branch-selector__item--active' : ''}`}
              onClick={() => { selectBranch(b._id); setOpen(false); }}
            >
              {b.name}
              {selectedBranchId === b._id && <Check size={14} className="branch-selector__check" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default BranchSelector;
